import Joi from 'joi';

import {
	api as apiRequest,
	batchApi as batchApiRequest
} from '@culture/common-helpers/request';
import {
	addCleanCache,
	parsePathParams,
	preparePathParams,
	getBreadcrumbsParams,
	getMetaParams
} from '@culture/common-helpers/params';
import Template from 'pageTemplates/lectures/movies/main';
import { getCatalogMeta, getBreadcrumbs, getRubrics } from 'logic/page';

const LecturesMoviesPage = (props) => <Template {...props} />;

const getLectures = (params, pathParams, rubricPath) => {
	let lecturesParams = addCleanCache(
		{
			statuses: ['published'],
			fields: [
				'title',
				'thumbnailFile',
				'duration',
				'genres',
				'year',
				'name',
				'type',
				'tifloComments',
				'participants',
				'rubrics'
			].join(),
			expand: ['genres', 'participants.type'],
			rubricPath,
			limit: params.limit,
			page: params.page,
			sort: params.sort,
			cached: true,
			isLikeCatalog: true
		},
		params.cleanCache
	);

	lecturesParams = preparePathParams(lecturesParams, pathParams);

	if (params.query) {
		lecturesParams = { ...lecturesParams, query: params.query };
	}

	return apiRequest('movies', lecturesParams);
};

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		pathParams: Joi.array().items(Joi.string()),
		cleanCache: Joi.boolean(),
		page: Joi.number().default(1),
		limit: Joi.number().default(36),
		sort: Joi.string().default('-publishDate'),
		query: Joi.string()
	});

	const pathParamsValidationSchema = Joi.object().keys({
		lecturer: Joi.string(),
		year: Joi.number()
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const parsedPathParams = parsePathParams(params.pathParams);

	let rubricPath = 'lectures/movies';

	if (parsedPathParams.rubric.length) {
		rubricPath += `/${parsedPathParams.rubric.join('/')}`;
	}

	const pathParams = Joi.attempt(
		parsedPathParams.params,
		pathParamsValidationSchema
	);

	const [rubrics, lectures, breadcrumbs, catalogMeta] = await batchApiRequest([
		getRubrics(rubricPath),
		getLectures(params, pathParams, rubricPath),
		getBreadcrumbs(getBreadcrumbsParams(rubricPath, params)),
		getCatalogMeta(getMetaParams(rubricPath, params, pathParams))
	]);

	return {
		props: {
			breadcrumbs,
			lectures: lectures.items,
			total: lectures.total,
			limit: params.limit,
			catalogMeta,
			rubricPath,
			urlParams: {
				...pathParams,
				sort: params.sort,
				page: params.page,
				query: params.query || ''
			},
			rubric: rubrics.items.length ? rubrics.items[0] : null
		}
	};
}

export default LecturesMoviesPage;
